import React from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { connect } from "react-redux";
import { pushAnswer } from "api/answer/index";

import SweetAlert from "react-bootstrap-sweetalert";

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";
//import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class FaqPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      q8: "",
      q9: "",
      q10: "",
      t1: "",
      t2: "",
      t3: "",
      t4: "",
      t5: "",
      t6: "",
      t7: "",
      t8: "",
      t9: "",
      t10: "",
      msg: "",
      alert: null
    };
  }

  handleChange = (keys, vals) => {
    this.setState({
      [keys]: vals
    });
  };

  handleSubmit = () => {
    console.log(this.state);
    pushAnswer(this.state)
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
        this.successAlert();
        //this.successAlert;
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  successAlert = () => {
    console.log("asd");
    this.setState({
      alert: (
        <NavLink to={"/portal"}>
          <SweetAlert
            success
            title=""
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            <font color="black">Your feed back sended. </font>
          </SweetAlert>
        </NavLink>
      )
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container} style={{ color: "black" }}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h2>MGTZ Test</h2>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>1. What is AIS?</h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q1"
                name="q1"
                value={this.state.q1}
                onChange={e => this.handleChange("q1", e.target.value)}
              >
                <FormControlLabel
                  value="Automatic Identification System"
                  control={<Radio style={{ color: "black" }} />}
                  label={
                    <h5 style={{ color: "black" }}>
                      Automatic Identification System
                    </h5>
                  }
                />
                <FormControlLabel
                  value="Advanced Info Service"
                  control={<Radio style={{ color: "black" }} />}
                  label={
                    <h5 style={{ color: "black" }}>Advanced Info Service</h5>
                  }
                />
                <FormControlLabel
                  value="Artificial Intelligence Software"
                  control={<Radio style={{ color: "black" }} />}
                  label={
                    <h5 style={{ color: "black" }}>
                      Artificial Intelligence Software
                    </h5>
                  }
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>2. What is the type of AIS antenna?</h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q2"
                name="q2"
                value={this.state.q2}
                onChange={e => this.handleChange("q2", e.target.value)}
              >
                <FormControlLabel
                  value="HF"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>HF</h5>}
                />
                <FormControlLabel
                  value="VHF"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>VHF</h5>}
                />
                <FormControlLabel
                  value="UHF"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>UHF</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>3. What is the interface of our system?</h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q3"
                name="q3"
                value={this.state.q3}
                onChange={e => this.handleChange("q3", e.target.value)}
              >
                <FormControlLabel
                  value="Serial port"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Serial port</h5>}
                />
                <FormControlLabel
                  value="Wi-Fi"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Wi-Fi</h5>}
                />
                <FormControlLabel
                  value="Both of the above"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Both of the above</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>4. If you want to enlarge the map, what function you need? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q4"
                name="q4"
                value={this.state.q4}
                onChange={e => this.handleChange("q4", e.target.value)}
              >
                <FormControlLabel
                  value="Zoom In"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Zoom In</h5>}
                />
                <FormControlLabel
                  value="Zoom Out"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Zoom Out</h5>}
                />
                <FormControlLabel
                  value="Pan"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Pan</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>5. Where can we find the SAR routes function? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q5"
                name="q5"
                value={this.state.q5}
                onChange={e => this.handleChange("q5", e.target.value)}
              >
                <FormControlLabel
                  value="Track"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Track</h5>}
                />
                <FormControlLabel
                  value="Route"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Route</h5>}
                />
                <FormControlLabel
                  value="MOB"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>MOB</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>6. We can update weather forecast information via? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q6"
                name="q6"
                value={this.state.q6}
                onChange={e => this.handleChange("q6", e.target.value)}
              >
                <FormControlLabel
                  value="Internet Download"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Internet Download</h5>}
                />
                <FormControlLabel
                  value="E-Mail"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>E-Mail</h5>}
                />
                <FormControlLabel
                  value="Both of the above"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Both of the above</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>7. Which tool can help us to measure length? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q7"
                name="q7"
                value={this.state.q7}
                onChange={e => this.handleChange("q7", e.target.value)}
              >
                <FormControlLabel
                  value="Divider"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Divider</h5>}
                />
                <FormControlLabel
                  value="GoTo"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>GoTo</h5>}
                />
                <FormControlLabel
                  value="Boundary Area"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Boundary Area</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>8. How to find out our own ship in fastest? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q8"
                name="q8"
                value={this.state.q8}
                onChange={e => this.handleChange("q8", e.target.value)}
              >
                <FormControlLabel
                  value="Zoom Out"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Zoom Out</h5>}
                />
                <FormControlLabel
                  value="Center On"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Center On</h5>}
                />
                <FormControlLabel
                  value="Zoom In"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Zoom In</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>9. How to configure the AIS input source? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q9"
                name="q9"
                value={this.state.q9}
                onChange={e => this.handleChange("q9", e.target.value)}
              >
                <FormControlLabel
                  value="Import/Export"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Import/Export</h5>}
                />
                <FormControlLabel
                  value="Manage ENC"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Manage ENC</h5>}
                />
                <FormControlLabel
                  value="Connection Wizard"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Connection Wizard</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>
              10. If we have questions about MGTZ, which function can help us to
              find out the answer?{" "}
            </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="q10"
                name="q10"
                value={this.state.q10}
                onChange={e => this.handleChange("q10", e.target.value)}
              >
                <FormControlLabel
                  value="User Guide"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>User Guide</h5>}
                />
                <FormControlLabel
                  value="Options"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Options</h5>}
                />
                <FormControlLabel
                  value="Exit"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>Exit</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>True Or False </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>1. We can get AIS data from internet in MGTZ.? </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t1"
                name="t1"
                value={this.state.t1}
                onChange={e => this.handleChange("t1", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>2. We can import/export marks/routes/tracks in MGTZ. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t2"
                name="t2"
                value={this.state.t1}
                onChange={e => this.handleChange("t2", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>3. MGTZ without export AIS list functions. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t3"
                name="t3"
                value={this.state.t3}
                onChange={e => this.handleChange("t3", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>4. MGTZ does not support sea map chart extension. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t4"
                name="t4"
                value={this.state.t4}
                onChange={e => this.handleChange("t4", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>5. We can download weather forecast information in MGTZ. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t5"
                name="t5"
                value={this.state.t5}
                onChange={e => this.handleChange("t5", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>
              6. We can simulate the weather and ship voyage in MGTZ planning
              function.{" "}
            </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t6"
                name="t6"
                value={this.state.t6}
                onChange={e => this.handleChange("t6", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>7. There is only support 2D map in MGTZ. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t7"
                name="t7"
                value={this.state.t7}
                onChange={e => this.handleChange("t7", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>8. MGTZ does not support multiple layers. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t8"
                name="t8"
                value={this.state.t8}
                onChange={e => this.handleChange("t8", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>9. We can edit routes in MGTZ. </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t9"
                name="t9"
                value={this.state.t9}
                onChange={e => this.handleChange("t9", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <br />
            <p />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <h4>
              10. If lost GPS signal, the own ship will became black color.{" "}
            </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <FormControl
              component="fieldset"
              style={{ color: "black !important" }}
            >
              <RadioGroup
                aria-label="t10"
                name="t10"
                value={this.state.t10}
                onChange={e => this.handleChange("t10", e.target.value)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>False</h5>}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "black" }} />}
                  label={<h5 style={{ color: "black" }}>True</h5>}
                />
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <font color="green">{this.state.msg}</font>
            <Button
              color="rose"
              onClick={this.handleSubmit}
              //onClick={this.successAlert}
            >
              Submit
            </Button>
          </GridItem>
        </GridContainer>
        {this.state.alert}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

FaqPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(connect(
  mapStateToProps,
  { pushAnswer }
)(withStyles(pricingPageStyle)(FaqPage)));
